import React, {useContext} from "react";
import omniscanLogo from "../../images/omniscanlogo.png";

export default function PageHeader({title}){
	
	
	
	const thisContainer = {
			position:"fixed",
			left:"0px",
			top:"0px",
			display:'flex',
			width:"100%",
			boxShadow:'0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.08)',
			justifyContent:"space-between",
			alignItems:"center"
	};
	
	const logoContainer = {
		display:'flex',
		margin:"10px"
	};
	
	const logoStyle = {
		display:'flex',
		width:"10vw",
		height:"auto"
	};
	
	const titleContainer = {
		display:'flex',
		fontSize:"16px",
		fontWeight:"bold",
		paddingRight:"30px"
	};
	
	return (
		<div style={thisContainer}>
			<div style={logoContainer}>
   			<img src={omniscanLogo} style={logoStyle}/>
   		</div>
   		<div style={titleContainer}>
   			{title}
   		</div>
		</div>
	);
}